import { ReactElement } from 'react'
import { SvgIcon } from '@mui/material'
import Icon from 'src/assets/icons/addingSlabsIcon.svg?react'

const Slab = (): ReactElement => {
  return <SvgIcon component={Icon} inheritViewBox />
}

export default Slab
